﻿export const SUCCESS = 'Success';
export const WARNING = 'Warning';
export const ERROR = 'Error';
export const MESSAGE = 'Message';
export const USER_NOTIFICATION = 'UserNotification';

export const USER_NOTIFICATION_BANNER = "BANNER";
export const USER_NOTIFICATION_POPUP = "POPUP";
export const USER_NOTIFICATION_NOTIFICATION = "NOTIFICATION";

export const ALERT_SUCCESS = 'AlertSuccess';
export const ALERT_WARNING = 'AlertWarning';
export const ALERT_ERROR = 'AlertError';
export const ALERT_INFO = 'AlertInfo';
export const HIDE_ALERT = 'HideAlert';

export const SHOW_ALERT = 'ShowAlert';
export const SHOW_CONFIRM = 'ShowConfirm';
export const CONFIRM_YES = 'ConfirmYes';
export const CONFIRM_NO = 'ConfirmNo';

export const SHOW_LOADING_PANEL = 'ShowLoadingPanel';
export const HIDE_LOADING_PANEL = 'HideLoadingPanel';

export const HIDE_SCROLLBAR = "HideScrollbar";

export const FINISH_LOADING = "FinishLoading";
export const WF_DISPLAYED = "WFDisplayed";

export const SIZE_CHANGED = "SizeChanged";

export const SHOW_FEATURE = "ShowFeature";
export const REFRESH_LAYER = "RefreshLayer";
export const REFRESH_LAYER_BY_ENTITY_ID = "RefreshLayerByEntityId";
export const GET_SELECTED_FEATURES = "GetSelectedFeatures";
export const SELECTED_FEATURES = "SelectedFeatures";
export const EDIT_FEATURE_GEOMETRY_START = "EditFeatureGeometry_Start";
export const EDIT_FEATURE_GEOMETRY_STOP = "EditFeatureGeometry_Stop";
export const EDIT_FEATURE_GEOMETRY_SAVE = "EditFeatureGeometry_Save";
export const EDIT_FEATURE_GEOMETRY_CANCEL = "EditFeatureGeometry_Cancel";
export const EDIT_FEATURE_GEOMETRY_NO_FEATURE = "EditFeatureGeometry_NoFeature";

export const INSERT_FEATURE_GEOMETRY_START = "InsertFeatureGeometry_Start";
export const INSERT_FEATURE_GEOMETRY_STOP = "InsertFeatureGeometry_Stop";
export const INSERT_FEATURE_GEOMETRY_SAVE = "InsertFeatureGeometry_Save";
export const INSERT_FEATURE_GEOMETRY_CANCEL = "InsertFeatureGeometry_Cancel";


export const INSERT_FEATURE_GEOEMTRY = "InsertFeatureGeoemtry";

export const CLOSE_MODAL_WINDOW = "CloseModalWindow";
export const MINIMIZE_MODAL_WINDOW = "MinimizeModalWindow";
export const REDIRECT = "Redirect";

export const POINT_COORDINATES = "PointCoordinates";
export const GET_POINT_COORDINATES = "GetPointCoordinates";

export const CENTER_MAP = "CenterMap";


export const SHOW_TEMPORARY_POINT = "ShowTemporaryPoint";

export const UPDATE_LAYOUT = "UpdateLayout";

export const XP_CONNECTION_ID = 'XPConnectionId';
export const WF_CONNECTION_ID = 'WFConnectionId';


export const SET_PANEL_HEADER = 'SetPanelHeader';

export const SHOW_MODAL_WINDOW = "ShowModalWindow";
export const MODAL_FINISH_LOADING = "ModalFinishLoading";
export const MODAL_SIZE_CHANGED = "ModalSizeChanged";
export const MESSAGE_FROM_MODAL = "MessageFromModal";

export const MODAL_WINDOW_HAS_CLOSED = "ModalWindowHasClosed";

export const GET_CURRENT_URL = "GetCurrentURL";
export const CURRENT_URL = "CurrentURL";

export const SHOW_FEATURE_BY_ENTITY_ID = "ShowFeatureBYEntityId";